export default __webpack_public_path__ + "static/media/1E.154e17e1.png";